<template>
    <div class="wap">
        <div class="head">
            <div class="logo">
                <router-link to="/">
                    <img src="../assets/img/logo_header.svg" style="margin-top:10px;" />
                </router-link>
            </div>

            <div class="userinfo">
                <div class="container" @click="toggleFeature()">
                    <div class="expand"></div>
                    <div>{{this.$store.state.email.split('@')[0]}}</div>
                </div>
                <div class="feature" :class="{hidden:this.IsShowFeature===false}">
                    <div class="item last">
                        <div @click="logout()">Log Out</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="main">
            <slot></slot>
        </div>

        <div class="bottomBar" style="display:none" :class="{hidden:this.IsShowBottomBar===false}">
            <i :class="{hidden:this.IsShowGotoTop===false}">
                <el-button type="primary" @click="goTop()" style="margin-left:0px;background-color:#00aff0 !important">
                    <i class="el-icon-caret-top"></i>
                </el-button>
            </i>
        </div>
        <div class="foot">
            <div class="logoLast">
                <img src="../assets/img/logo_footer.svg" style="margin:22px 40px 0px 20px" />
            </div>
            <span>
                <a href="https://helpcenter.ef.com/" style="color:#dedede;text-decoration:none" target="_blank">Help Center</a>
                <br />
                <br /> © Ying Fu Jiao Yu 2025. All rights reserved.
            </span>
        </div>
    </div>
</template>
<style>
body {
  margin: 0;
  overflow-x: hidden;
  overflow-y: auto;
}

@font-face {
  font-family: HelveticaNeueBold;
  src: url("../assets/font/HelveticaNeue-Bold.ttf");
}

@font-face {
  font-family: HelveticaNeue;
  src: url("../assets/font/HelveticaNeue.ttf");
}

@font-face {
  font-family: HelveticaNeue-Medium;
  src: url("../assets/font/HelveticaNeue-Medium.ttf");
}

@font-face {
  font-family: HelveticaNeue-CondensedBold;
  src: url("../assets/font/HelveticaNeue-CondensedBold.ttf");
}

.wap {
  width: 100%;
  min-width: 1024px;
  min-height: 500px;
  /*height: auto;*/
  margin-right: auto;
  margin-left: auto;
}

.head {
  width: 100%;
  height: 65px;
  background: #fff;
  box-shadow: 0px 0.5px 3px;
}

#ReportTitle {
  float: left;
  font-family: "HelveticaNeue";
  height: 100%;
  line-height: 65px;
  font-size: 24px;
  font-style: italic;
  color: #666;
}

.logo {
  width: 68px;
  margin-left: 20px;
  height: 65px;
  float: left;
  text-align: left;
}

.userinfo {
  float: right;
  /*width: 150px;*/
  height: 100%;
  padding-right: 40px;
  position: relative;
  font-size: 16px;
  font-family: "HelveticaNeue";
}

.userinfo .container {
  cursor: pointer;
  height: 100%;
}

.userinfo .container > div {
  display: inline-block;
  vertical-align: middle;
}

.userinfo .container .expand {
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: contain;
  height: 100%;
  margin-right: 13px;
  width: 20px;
  background-image: url("../assets/img/dropdown.svg");
}

.feature {
  background-color: #fff;
  box-shadow: 0 0.3125rem 0.625rem rgba(0, 0, 0, 0.3);
  position: absolute;
  right: 0;
  top: calc(100% + 0.0625rem);
  z-index: 1000;
}

.item {
  -webkit-transition: none;
  transition: none;
}

.item:hover {
  background-color: #0087e6;
  color: #fff;
}

.item > div {
  border-bottom: 1px solid #999;
  border-bottom: 0.0625rem solid #999;
  cursor: pointer;
  margin: 0 20px;
  margin: 0 1.25rem;
  min-width: 100px;
  min-width: 6.25rem;
  padding: 10px 0;
  padding: 0.625rem 0;
  -webkit-transition: none;
  transition: none;
  font-family: Helvetica Neue, Microsoft YaHei, sans-serif;
  font-size: 14px;
  font-weight: 500;
}

.item.last > div {
  border-bottom: none;
}

.main {
  width: 100%;
  height: 100%;
  min-height: 500px;
  overflow: hidden;
  background-color: #f2f2f2;
  background-size: 83px 100%;
  box-shadow: 0px 0.5px 3px;
  padding-bottom: 20px;
}

.Content {
  width: 94.5%;
  padding-left: 28px;
  padding-right: 33px;
}

.iconPadding {
  padding: 10px;
}

.menu {
  width: 100%;
  float: left;
  min-height: 60px;
  overflow: hidden;
  padding-bottom: 5px;
}

.foot {
  width: 100%;
  height: 80px;
  background: #4a4a4a;
  text-align: left;
  color: #dedede;
  font-size: 12px;
  font-family: "HelveticaNeue";
}

.logoLast {
  float: left;
  width: 106px;
}

.foot span {
  float: left;
  margin-top: 20px;
}

.el-dialog--small {
  width: 56% !important;
}

.el-tabs__item {
  height: 36px !important;
  line-height: 36px !important;
}

.Color1 {
  background-color: #1ebcc5;
}

.Color2 {
  background-color: #54c0ab;
}

.Color3 {
  background-color: #b7ca33;
}

.Color4 {
  background-color: #f16b6a;
}

.Color5 {
  background-color: #ffc646;
}

.Color6 {
  background-color: #f7932d;
}

.Color7 {
  background-color: #ee4f85;
}

.Color8 {
  background-color: #9b519d;
}

.SubWap {
  width: 100%;
  height: auto;
  margin-right: auto;
  margin-left: auto;
  text-align: center;
}

.Submain {
  width: 100%;
  background-color: #fff;
  box-shadow: 0px 0.5px 3px;
  padding-bottom: 60px;
}

.SubContent {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 2px;
}

#TableauVizContainer {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
}

.closeButton {
  opacity: 0.55;
  filter: alpha(opacity=55);
  zoom: 1;
}

.closeButton:hover {
  opacity: 1;
  filter: alpha(opacity=100);
  zoom: 1;
}

.closeHref a:hover div {
  background: #456981;
}

.closeHref a div {
  background: #456981;
}

.hidden {
  display: none;
}

.bottomBar {
  border: 2px;
  border-radius: 8px;
  padding: 8px;
  z-index: 999998;
  position: fixed;
  bottom: 10px;
  right: 120px;
  background: #dedede;
}

.iconMark {
  margin-right: 2px;
  width: 15px;
  height: 15px;
}

iframe{
  margin:0 auto;
}

</style>

<script>
import userMgr from "../sso";
import * as api from "../api";
import router from "../router";
//import initZendeskWidget from "../zendesk/widget"

export default {
  data() {
    return {
      IsShowFeature: false,
      IsShowBottomBar:
        this.ShowBottomBar == undefined ? true : this.ShowBottomBar,
      IsShowGotoTop: false,
      IsNeedLogin: this.NeedLogin == undefined ? true : this.NeedLogin
    };
  },
  props: [
    "ShowBottomBar",
    "NeedLogin",
    "HideGotoTop",
    "ResizeCallback"
  ],
  created() {
    this.checkAuth();
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted() {},
  components: {
  },
  methods: {
    checkAuth: function() {
      localStorage.lastPathUrl = location.pathname + location.search;
      if (this.$store.state.accessToken === "") {
        if (this.IsNeedLogin) {
          userMgr.signinRedirect();
        }
      } else {
        if (this.$store.state.isLoaded === false) {
          api.getAuth().then(
            response => {
              this.$store.commit("load", response.body);

              const name = this.$store.state.email.split('@')[0];
              const email = this.$store.state.email;
              //initZendeskWidget(response.body.Jwt, name, email);
            },
            response => {
              console.log("failed");
              console.log(response);
            }
          );
        }
      }
    },
    logout: function() {
      userMgr.signoutRedirect();
    },
    toggleFeature: function() {
      this.IsShowFeature = !this.IsShowFeature;
    },
    handleResize: function() {
      if (this.ResizeCallback) {
        this.ResizeCallback();
      }
    },
    goTop: function() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    handleScroll: function() {
      var scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop || 0;
      if (scrollTop > 300) {
        this.IsShowGotoTop = true;
      } else {
        this.IsShowGotoTop = false;
      }
    },
    showBottomBar: function() {
      this.IsShowBottomBar = true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// MainLayout.vue?04374c9b